module.exports = __webpack_public_path__ + "img/17_Upper-Rectum.3ad7a78e.png";